module.exports = __webpack_public_path__ + "static/media/emojis2_15.06312401.svg";